import { __extends } from "tslib";
import { isDefined } from '@tyler-components-web/core';
import { AbstractComponentDelegate } from '../core/delegates/abstract-component-delegate';
import { TextFieldComponentDelegate } from '../text-field';
import { DATEPICKER_CONSTANTS } from './datepicker-constants';
var DatepickerComponentDelegate = /** @class */ (function (_super) {
    __extends(DatepickerComponentDelegate, _super);
    function DatepickerComponentDelegate(config) {
        if (config === void 0) { config = {}; }
        return _super.call(this, config) || this;
    }
    DatepickerComponentDelegate.prototype.build = function () {
        var datepicker = document.createElement(DATEPICKER_CONSTANTS.elementName);
        if (!this._config.textFieldConfig) {
            this._config.textFieldConfig = {};
        }
        // Map properties from top-level config to text-field config
        if (isDefined(this._config.placeholder)) {
            this._config.textFieldConfig.placeholder = this._config.placeholder;
        }
        if (isDefined(this._config.required)) {
            this._config.textFieldConfig.required = this._config.required;
        }
        if (isDefined(this._config.label) && this._config.label) {
            this._config.textFieldConfig.label = this._config.label;
        }
        if (isDefined(this._config.density)) {
            this._config.textFieldConfig.density = this._config.density;
        }
        this._textFieldDelegate = new TextFieldComponentDelegate(this._config.textFieldConfig);
        datepicker.appendChild(this._textFieldDelegate.component);
        return datepicker;
    };
    DatepickerComponentDelegate.prototype.configure = function () {
        Object.assign(this._component, this._config);
    };
    DatepickerComponentDelegate.prototype.getInputElement = function () {
        return this._textFieldDelegate.inputElement;
    };
    DatepickerComponentDelegate.prototype.getTextFieldComponent = function () {
        return this._textFieldDelegate.component;
    };
    DatepickerComponentDelegate.prototype.getValue = function () {
        return this._textFieldDelegate.inputElement.value;
    };
    DatepickerComponentDelegate.prototype.setValue = function (value) {
        this._textFieldDelegate.inputElement.value = value;
    };
    DatepickerComponentDelegate.prototype.onChange = function (listener) {
        if (this._component.masked) {
            this._component.addEventListener(DATEPICKER_CONSTANTS.events.INPUT, function (evt) { return listener(evt.target.value); });
        }
        else {
            this.getInputElement().addEventListener('input', function (evt) { return listener(evt.target.value); });
        }
    };
    DatepickerComponentDelegate.prototype.onInput = function (listener) {
        if (this._component.masked) {
            this._component.addEventListener(DATEPICKER_CONSTANTS.events.INPUT, function (evt) { return listener(evt.detail); });
        }
        else {
            this._textFieldDelegate.inputElement.addEventListener('input', function (evt) { return listener(evt.target.value); });
        }
    };
    DatepickerComponentDelegate.prototype.onFocus = function (listener) {
        this._textFieldDelegate.inputElement.addEventListener('focus', function (evt) { return listener(evt); });
    };
    DatepickerComponentDelegate.prototype.onBlur = function (listener) {
        this._textFieldDelegate.inputElement.addEventListener('blur', function (evt) { return listener(evt); });
    };
    DatepickerComponentDelegate.prototype.setDisabled = function (value) {
        this._component.disabled = value;
    };
    DatepickerComponentDelegate.prototype.setInvalid = function (value) {
        this._textFieldDelegate.component.invalid = value;
    };
    DatepickerComponentDelegate.prototype.validate = function () {
        return !!this._textFieldDelegate.inputElement.value.trim();
    };
    return DatepickerComponentDelegate;
}(AbstractComponentDelegate));
export { DatepickerComponentDelegate };
